import React, { useEffect } from 'react';

import { ga4Track, modalInteraction } from '@unisporkal/ga4';
import styles from './UltraPackUpsellForm.module.scss';
import UltraPackUpsellMessage from '../../Messages/UltraPackUpsellMessage/UltraPackUpsellMessage';
import UltraPacks from '../../UltraPacks/UltraPacks';
import Price from '../../Price/Price.tsx';

const UltraPackUpsellForm = () => {
  useEffect(() => {
    const ga4Event = modalInteraction({
      event: 'open_modal',
      modal_content: 'ultrapack_options',
      cta_text: 'get_this_image_ultrapack',
      ui_element_location: 'adp_buy_card',
      modal_type: 'selectors_cta_modal',
    });
    ga4Track(ga4Event);
  }, []);

  return (
    <div className={styles.container}>
      <UltraPackUpsellMessage />
      <UltraPacks />
      <Price />
    </div>
  );
};

export default UltraPackUpsellForm;
